import Command from '@ckeditor/ckeditor5-core/src/command';
import { v4 as uuidv4 } from 'uuid';

export default class AddInlineCommentThread extends Command {
  execute() {
    const threadId = uuidv4();
    this.editor.editing.view.focus();
    this.editor.execute('addCommentThread', { threadId });
    return threadId;
  }

  refresh() {
    this.isEnabled = true;
  }
}
